import Grid from "@material-ui/core/Grid"
import { StyledNavigationText } from "components/NavigationItem/style"
import NavigationLink from "components/NavigationLink"
import Translation from "components/Translation"
import React, { memo } from "react"
import { RouteComponentProps, useLocation, withRouter } from "react-router-dom"
import { NavigationItemContainer, StyledIconContainer } from "./style"

type TTapBarItem = {
  name: string
  to: string
  icon: JSX.Element
  className?: string
} & RouteComponentProps

function TapBarItem({ name, to, icon: Icon, className }: TTapBarItem) {
  const { pathname } = useLocation()
  const isActive = to.split("/")[1] === pathname.split("/")[1]
  return (
    <NavigationLink to={to} className={className}>
      <NavigationItemContainer isActive={isActive}>
        <Grid container={true} spacing={0} direction="column" alignItems="center">
          {Icon && (
            <Grid item={true} xs={12}>
              <StyledIconContainer>{Icon}</StyledIconContainer>
            </Grid>
          )}
          <Grid item={true} xs={12}>
            <StyledNavigationText>
              <Translation label={name} />
            </StyledNavigationText>
          </Grid>
        </Grid>
      </NavigationItemContainer>
    </NavigationLink>
  )
}

export default withRouter(memo(TapBarItem))
